// Location responses may reference a city by database ID, code, or display name.
export const districtBelongsToCity = (district, city) => {
  if (!city || String(city.id) === '0') return false;
  const normalize = value => String(value ?? '').trim().toLowerCase();
  const cityKeys = [city.id, city.code, city.value].map(normalize).filter(Boolean);
  return String(district.city_id ?? '').split(',').map(normalize)
    .some(reference => reference && cityKeys.includes(reference));
};
